<template>
  <div :class="$vuetify.breakpoint.mobile ? 'mt-6' : ''">
    <v-divider></v-divider>
    <v-footer class="rounded-lg rounded-t-0 pb-0 caption text-justify">
      <p v-if="currentPaymentProvider == 'PixPay4FunGO'">
        {{ $t("pay4funWithdrawlFooterText1") }}
        <strong>{{ operatorName }}</strong
        >.
        {{ $t("pay4funWithdrawlFooterText2") }}
      </p>
      <p v-else-if="currentPaymentProvider == 'CarteiraPay4FunWallet'">
        {{ $t("walletWithdrawalFooter1") }}
        <strong>{{ operatorName }}</strong
        >.
        {{ $t("walletWithdrawalFooter2") }}
        <br />
        {{ $t("walletWithdrawalFooter2_1") }}
      </p>
      <p
        v-if="
          currentPaymentProvider == 'PixPaybrokers' ||
            currentPaymentProvider == 'PixPaybrokersV4'
        "
      >
        {{ $t("paybrokersFooter1") }}
        {{ $t("paybrokersFooter2") }}
      </p>
      <p v-if="currentPaymentProvider === 'PixBrasilCash'">
        {{ $t("brazilCashFooter") }}
        <br />
        {{ $t("brasilCashFooter2") }}
      </p>
      <p v-if="currentPaymentProvider === 'PixPaag'">
        {{ $t("paagFooter") }}
      </p>
      <p v-if="currentPaymentProvider === 'PixPaguePay'">
        {{ $t("paguePayFooter") }}
      </p>
      <p v-if="currentPaymentProvider === 'PixPagFast'">
        {{ $t("pagFastFooter") }}
      </p>
    </v-footer>
  </div>
</template>
<script>
export default {
  props: ["currentPaymentProvider"],
  computed: {
    operatorName() {
      return this.$store.state.operators.operator_name;
    },
  },
};
</script>